import { createAuthClient } from "@krix/auth/client";
import { useQuery } from "@tanstack/react-query";

const API_BASE = import.meta.env["VITE_API_BASE_URL"] ?? "http://localhost:3000";

export const authClient = createAuthClient({ baseURL: API_BASE });

interface SessionUser {
  id: string;
  email: string;
  name: string | null;
  image: string | null;
  emailVerified: boolean;
  role?: string;
}

interface SessionData {
  user: SessionUser;
  session: { id: string; userId: string; expiresAt: string };
}

export function useSession() {
  return useQuery<SessionData | null>({
    queryKey: ["session"],
    queryFn: async () => {
      const res = await fetch(`${API_BASE}/api/auth/get-session`, {
        credentials: "include",
      });
      if (!res.ok) return null;
      if (res.status === 204) return null;
      const text = await res.text();
      if (!text) return null;
      try {
        return JSON.parse(text);
      } catch {
        return null;
      }
    },
    staleTime: 30_000,
  });
}

export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}
